import { LocalDateTime, ZoneOffset } from '@js-joda/core';

/**
 * Returns the difference between the param and current time, endDate should be seconds
 * @param endDate number(time in seconds)
 */
export const getDifferenceInMinutesFromNow = (endDate: number) => {
  const now = LocalDateTime.now().toEpochSecond(ZoneOffset.UTC);

  const differenceInSeconds = endDate - now;
  const difference = differenceInSeconds * 1000;

  if (differenceInSeconds <= 0) {
    return { time: '0:00', difference };
  }

  const minutes = Math.floor(differenceInSeconds / 60);
  const seconds = differenceInSeconds % 60;

  const time = `${minutes}:${String(seconds).padStart(2, '0')}`;

  return { time, difference };
};
